'use client';

import React, { createContext, useContext } from 'react';

export interface SalesforceEmbedContextValue {
  isEmbed: boolean;
  token?: string;
  clientId?: string;
  contactId?: string;
  expiresAt?: number;
}

const SalesforceEmbedContext = createContext<SalesforceEmbedContextValue>({
  isEmbed: false,
});

export const SalesforceEmbedProvider: React.FC<{
  value: SalesforceEmbedContextValue;
  children: React.ReactNode;
}> = ({ value, children }) => {
  return (
    <SalesforceEmbedContext.Provider value={value}>{children}</SalesforceEmbedContext.Provider>
  );
};

export const useSalesforceEmbed = () => useContext(SalesforceEmbedContext);
